import { actions, paths, gameKeys } from 'src/constants';
import { MAX_PAGE_SIZE } from 'src/constants/common';

export default {
  getCollections: (page, pageSize = MAX_PAGE_SIZE) => ({
    [actions.API_CALL]: {
      types: [
        actions.ARTICULATION_GYMNASTICS_COLLECTIONS_GET_REQUEST,
        actions.ARTICULATION_GYMNASTICS_COLLECTIONS_GET_SUCCESS,
        actions.ARTICULATION_GYMNASTICS_COLLECTIONS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.ARTICULATION_GYMNASTICS, {
          params: {
            page,
            pageSize,
            gameKey: gameKeys.ARTICULATION_GYMNASTICS,
          },
        }),
    },
  }),
  getLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.ARTICULATION_GYMNASTICS_LEVELS_GET_REQUEST,
        actions.ARTICULATION_GYMNASTICS_LEVELS_GET_SUCCESS,
        actions.ARTICULATION_GYMNASTICS_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(
            paths.api.ARTICULATION_GYMNASTICS_COLLECTIONS_ID_LEVELS,
            collectionId
          )
        ),
    },
  }),
};
